module.exports = __webpack_public_path__ + "media/side_menu_icons/wizard_components-f60d708f.png";